import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { WebPage } from '../../models';

@Component({
  selector: 'app-page-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  template: `
    <h2 mat-dialog-title>{{ data.page ? 'Editar Página' : 'Registrar Nueva Página' }}</h2>

    <mat-dialog-content>
      <form [formGroup]="form" class="page-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nombre</mat-label>
          <input matInput formControlName="name" placeholder="Ej: Portal Principal">
          <mat-error *ngIf="form.get('name')?.hasError('required')">
            El nombre es requerido
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>URL</mat-label>
          <input matInput formControlName="url" placeholder="https://ejemplo.com">
          <mat-error *ngIf="form.get('url')?.hasError('required')">
            La URL es requerida
          </mat-error>
          <mat-error *ngIf="form.get('url')?.hasError('pattern')">
            Ingrese una URL válida
          </mat-error>
        </mat-form-field>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancelar</button>
      <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid">
        {{ data.page ? 'Guardar Cambios' : 'Registrar Página' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    h2 {
      font-family: var(--font-display);
      font-weight: 700;
      letter-spacing: -0.02em;
    }

    .page-form {
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-width: 500px;
      padding-top: 8px;
    }

    .full-width {
      width: 100%;
    }

    mat-dialog-content {
      padding-top: 0;
    }

    mat-dialog-actions {
      padding: 16px 0 0 0;
    }
  `]
})
export class PageDialogComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<PageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { page?: WebPage }
  ) {
    const urlPattern = /^https?:\/\/.+/;

    this.form = this.fb.group({
      name: [data.page?.name || '', Validators.required],
      url: [data.page?.url || '', [Validators.required, Validators.pattern(urlPattern)]],
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }
}
